module.exports = __webpack_public_path__ + "img/TNT_Vacature_0-4.e358fc42.webp";